function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#3f7cca}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bell",
  transform: "translate(-2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3505",
  transform: "translate(10.982)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11947",
  d: "M13.93 4.693a.562.562 0 0 1-.561-.561V2.245a1.123 1.123 0 0 0-2.245 0v1.887a.561.561 0 1 1-1.123 0V2.245a2.245 2.245 0 1 1 4.491 0v1.887a.561.561 0 0 1-.562.561z",
  className: "cls-1",
  transform: "translate(-10)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3506",
  transform: "translate(9.298 22.455)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11948",
  d: "M12.43 24.491a3.934 3.934 0 0 1-3.93-3.93.561.561 0 0 1 1.123 0 2.807 2.807 0 1 0 5.614 0 .561.561 0 0 1 1.123 0 3.934 3.934 0 0 1-3.93 3.93z",
  className: "cls-1",
  transform: "translate(-8.5 -20)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3507",
  transform: "translate(2 3.368)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11949",
  d: "M22.771 23.209H3.684a1.684 1.684 0 0 1-1.095-2.964 7.806 7.806 0 0 0 2.779-5.975v-3.411a7.859 7.859 0 1 1 15.718 0v3.411a7.8 7.8 0 0 0 2.77 5.967 1.684 1.684 0 0 1-1.086 2.972zM13.227 4.123a6.743 6.743 0 0 0-6.736 6.736v3.411a8.92 8.92 0 0 1-3.167 6.83.561.561 0 0 0 .36.991h19.087a.561.561 0 0 0 .365-.988 8.927 8.927 0 0 1-3.172-6.829v-3.415a6.743 6.743 0 0 0-6.736-6.736z",
  className: "cls-1",
  transform: "translate(-2 -3)"
})));

var SvgAlertIcon = function SvgAlertIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.455,
    height: 26.946,
    viewBox: "0 0 22.455 26.946",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-icon.89e6e428.svg";
export { ForwardRef as ReactComponent };